// Arranca rápido para detectar transiciones de flujo apenas ocurren y
// desacelera para no saturar al BE cuando el estado se mantiene estable.
const ADAPTIVE_POLLING_INTERVALS_MS = [
  1000, 1000, 2000, 2000, 3000, 5000, 5000, 10000,
];

export function adaptivePollingInterval(query: {
  state: { dataUpdateCount: number };
}): number {
  const idx = Math.min(
    query.state.dataUpdateCount,
    ADAPTIVE_POLLING_INTERVALS_MS.length - 1,
  );
  return ADAPTIVE_POLLING_INTERVALS_MS[idx];
}
